module.exports = __webpack_public_path__ + "static/media/noRecords.684ec86a.png";